import service from '@/services/types/distrito'

export const namespaced = true

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = [...state.list, ...objs])
}

export const actions = {
  listx: ({ commit }, value) =>
    service.list(value).then(result => {
      commit('LIST', result)
      return result
    }),

  list: ({ commit, state }, value) => {
    if (value) {
      const distrito = state.list.filter(c => c.idCanton === value)

      if (!distrito.length)
        return service.list(value).then(result => {
          console.log('distritos desde api 🥵 ', result.length)

          commit('LIST', result)

          return result
        })
      else {
        console.log('distritos en store ⏩')

        return distrito
      }
    }
  }
}
